import { CheckCircle2, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { money } from "@/lib/pricing";

// Check bar after copying an estimate: estimate items subtotal vs the copied lines' subtotal.
export function EstimateCheckBar({ job, rows }) {
  if (job.not_estimate) {
    return (
      <div data-testid="not-estimate-message" className="rounded-xl border border-amber-500/30 bg-amber-500/5 px-4 py-3 text-sm text-amber-200">
        This looks like a drawing/schedule, not an estimate. Your credit was refunded.{" "}
        <Link to="/" data-testid="read-drawings-instead-link" className="font-semibold underline">Use Read drawings instead</Link>
      </div>
    );
  }
  const copied = rows.reduce((a, r) => a + (r.calc?.final || 0), 0);
  const est = job.estimate_subtotal;
  const same = est != null && Math.abs(copied - est) < 0.005;
  const checks = rows.filter((r) => r.check_price).length;
  return (
    <div data-testid="estimate-check-bar" className={`flex flex-wrap items-center gap-x-6 gap-y-1 rounded-xl border px-4 py-3 text-sm ${same ? "border-emerald-500/40 bg-emerald-500/5 text-emerald-200" : "border-amber-500/40 bg-amber-500/5 text-amber-200"}`}>
      {same ? <CheckCircle2 className="h-4 w-4" /> : <AlertTriangle className="h-4 w-4" />}
      <span>Estimate items subtotal <b data-testid="estimate-subtotal" className="font-mono-num">{est != null ? money(est) : "not shown"}</b></span>
      <span>Copied subtotal <b data-testid="copied-subtotal" className="font-mono-num">{money(copied)}</b></span>
      <span data-testid="estimate-check-result" className="font-semibold">{same ? "Matches" : est != null ? `Off by ${money(Math.abs(copied - est))}` : "Check the prices"}</span>
      {checks > 0 && <span data-testid="estimate-check-price-count">{checks} line{checks === 1 ? "" : "s"} to check (unit × qty ≠ line total)</span>}
      <span className="text-xs opacity-80">Items only: customer, shipping, tax and notes are not copied.</span>
    </div>
  );
}
